module.exports = __webpack_public_path__ + "media/images/smart_phone/contents/23-bc5473d44b9d9ae79c34e003fca89f94.jpeg";